export default "__VITE_PUBLIC_ASSET__fdcea9e7__"